var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPayment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.23 7.9H6.78C5.24 7.9 4 9.14 4 10.67C4 20.63 4 21.36 4 21.36C4 21.37 4 21.37 4 21.38C4.03 22.89 5.26 24.1 6.77 24.1H25.22C26.75 24.1 27.99 22.86 27.99 21.32V10.67C28 9.14 26.76 7.9 25.23 7.9ZM26.09 21.32C26.09 21.8 25.71 22.19 25.23 22.19H6.78C6.32 22.19 5.95 21.83 5.92 21.39C5.92 17.85 5.92 19.27 5.92 15.31H26.1L26.09 21.32ZM26.09 11.92H5.91V10.68C5.91 10.2 6.3 9.81 6.77 9.81H25.22C25.7 9.81 26.08 10.2 26.08 10.67L26.09 11.92ZM8.32 18.41H17.96C18.85 18.41 18.85 17.06 17.96 17.06H8.32C7.41 17.06 7.47 18.41 8.32 18.41Z",
    fill: "#0000C2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.e02741f6617ae6f773abf370029b7037.svg";
export { ForwardRef as ReactComponent };